import {
  currentUserSelector,
  fetchUserChildUsers,
  fetchUserData,
  LoadingStatus,
  userLoadingStatus,
  userState,
} from '@hefe/store';
import axios from 'axios';
import { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* eslint-disable-next-line */
export interface AuthenticationProviderProps {
  token?: string;
  tokenExpiresAt: number;
  publicPaths: string[];
  SplashScreen: any;
}

export function AuthenticationProvider(
  props: PropsWithChildren<AuthenticationProviderProps>
) {
  const dispatch = useDispatch();
  const userLoading = useSelector(userLoadingStatus);
  const childUsersLoading = useSelector(userState).childUserLoadingStatus;
  const user = useSelector(currentUserSelector);

  const isUserLoaded =
    userLoading !== LoadingStatus.NOT_LOADED &&
    userLoading !== LoadingStatus.LOADING &&
    childUsersLoading !== LoadingStatus.NOT_LOADED &&
    childUsersLoading !== LoadingStatus.LOADING;

  useEffect(() => {
    // Axios defaults
    axios.defaults.withCredentials = true;
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + props.token;
    axios.defaults.headers.common['Content-Type'] = 'application/json';

    /*
  TODO add if needed! 
  // Checking bevfore every Request if token is expired
  axios.interceptors.request.use(
    (config) => {
      return new Promise((resolve, reject) => {
        const expires_at = props.tokenExpiresAt;
        const tokenIsExpired: boolean = expires_at < Date.now();

        let isPublicPath = false;

        for (const path of PublicApiPaths) {
          if (config.url?.includes(path)) {
            isPublicPath = true;
          }
        }

        if (tokenIsExpired && !isPublicPath) {
              this.props.refreshUserToken((success, token) => {
                  if (success) {
                    if (config.headers) {
                      config.headers['Authorization'] = 'Bearer ' + token;
                    }
                      resolve(config);
                  } else {
                      reject(config);
                  }
              });
        } else {
          resolve(config);
        }
      });
    },
    (err) => {
      Promise.reject(err.response);
    }
  );
  */

    if (props.token) {
      dispatch(fetchUserData() as any);
      dispatch(fetchUserChildUsers() as any);
    }
  }, [props.token]);

  // TODO set to isUserLoaded
  if (user || isUserLoaded || !props.token) {
    return <>{props.children}</>;
  } else {
    return props.SplashScreen;
  }
}

export default AuthenticationProvider;
